if (!customElements.get('quick-view-button')) {
  (() => {
    const MOBILE_QUERY = '(max-width: 640px)';

    async function qvAddToCart(variantId) {
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = new FormData();
      body.append('id', variantId);
      body.append('quantity', 1);
      if (cart) {
        body.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.id).join(',')
        );
        body.append('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = body;

      try {
        const response = await fetch(`${routes.cart_add_url}`, config).then((r) => r.json());
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'quick-view',
            productVariantId: variantId,
            errors: response.errors || response.description,
            message: response.message,
          });
          return { ok: false, message: response.description || response.message };
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'quick-view',
          productVariantId: variantId,
          cartData: response,
        });
        return { ok: true, cart, response };
      } catch (e) {
        console.error(e);
        return { ok: false, message: window.cartStrings ? window.cartStrings.error : 'Something went wrong.' };
      }
    }

    // Delivery estimate — same rules as the cart drawer (2pm cutoff, business
    // days only, UK bank holidays from gov.uk shared via the same session cache)
    const QV_CUTOFF_HOUR = 14;
    const QV_STANDARD_DAYS = 2;
    const QV_FALLBACK_HOLIDAYS = [
      '2025-01-01', '2025-04-18', '2025-04-21', '2025-05-05', '2025-05-26',
      '2025-08-25', '2025-12-25', '2025-12-26',
      '2026-01-01', '2026-04-03', '2026-04-06', '2026-05-04', '2026-05-25',
      '2026-08-31', '2026-12-25', '2026-12-28',
    ];

    if (!sessionStorage.getItem('uk_bank_holidays')) {
      fetch('https://www.gov.uk/bank-holidays.json')
        .then((r) => r.json())
        .then((data) => {
          const events = (data['england-and-wales'] || {}).events || [];
          sessionStorage.setItem('uk_bank_holidays', JSON.stringify(events.map((e) => e.date)));
        })
        .catch(() => {});
    }

    function qvDeliveryDate() {
      let holidays = QV_FALLBACK_HOLIDAYS;
      try {
        const cached = sessionStorage.getItem('uk_bank_holidays');
        if (cached) holidays = JSON.parse(cached);
      } catch (e) {
        /* fallback list already set */
      }
      const isBusinessDay = (d) => {
        const day = d.getDay();
        if (day === 0 || day === 6) return false;
        return !holidays.includes(d.toISOString().split('T')[0]);
      };
      const now = new Date();
      const dispatch = new Date(now);
      if (!(now.getHours() < QV_CUTOFF_HOUR && isBusinessDay(now))) {
        do {
          dispatch.setDate(dispatch.getDate() + 1);
        } while (!isBusinessDay(dispatch));
      }
      const delivery = new Date(dispatch);
      let added = 0;
      while (added < QV_STANDARD_DAYS) {
        delivery.setDate(delivery.getDate() + 1);
        if (isBusinessDay(delivery)) added++;
      }
      return delivery;
    }

    function qvFormatDate(d) {
      const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return `${days[d.getDay()]} ${d.getDate()} ${months[d.getMonth()]}`;
    }

    // "Extra Extra Small" -> XXS, "Extra Small" -> XS, "Small" -> S, etc.
    function qvSizeAbbrev(value) {
      const key = value.trim().toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ');
      const map = { small: 'S', medium: 'M', large: 'L' };
      if (map[key]) return map[key];
      const m = key.match(/^((?:extra )+)(small|large)$/);
      if (m) return 'X'.repeat(m[1].trim().split(' ').length) + (m[2] === 'small' ? 'S' : 'L');
      return value;
    }

    function qvShowCart(cart, response) {
      if (cart) {
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(response);
      } else {
        window.location = routes.cart_url;
      }
    }

    class QuickViewModal {
      constructor() {
        this.data = null;
        this.selected = [];
        this.imageIndex = 0;
        this.chartMode = false;
        this.adding = false;
        this.mq = window.matchMedia(MOBILE_QUERY);
        this.build();
      }

      build() {
        this.root = document.createElement('div');
        this.root.className = 'qv-modal';
        this.root.hidden = true;
        this.root.innerHTML = `
          <div class="qv-modal__overlay" data-qv-overlay></div>
          <div class="qv-modal__pos">
            <div class="qv-modal__card" role="dialog" aria-modal="true" tabindex="-1">
              <button type="button" class="qv-modal__close" data-qv-close>&#10005;</button>
              <div class="qv-gallery" data-qv-gallery></div>
              <div class="qv-media">
                <div class="qv-media__main" data-qv-main></div>
                <div class="qv-thumbs" data-qv-thumbs></div>
              </div>
              <div class="qv-info">
                <div class="qv-heading">
                  <div class="qv-rating" data-qv-rating hidden></div>
                  <h2 class="qv-title" data-qv-title></h2>
                  <div class="qv-price" data-qv-price></div>
                </div>
                <div class="qv-usps" data-qv-usps></div>
                <div data-qv-options></div>
                <p class="qv-stock" data-qv-stock hidden></p>
                <div class="qv-footer">
                  <p class="qv-delivery" data-qv-delivery hidden></p>
                  <div class="qv-actions" data-qv-actions>
                    <button type="button" class="qv-atc" data-qv-atc></button>
                    <a href="#" class="qv-view-product" data-qv-view></a>
                    <a href="#" class="qv-view-bundle" data-qv-bundle-link hidden></a>
                  </div>
                  <p class="qv-error" data-qv-error hidden></p>
                </div>
              </div>
            </div>
          </div>
        `;
        document.body.appendChild(this.root);

        this.card = this.root.querySelector('.qv-modal__card');
        this.gallery = this.root.querySelector('[data-qv-gallery]');
        this.mainMedia = this.root.querySelector('[data-qv-main]');
        this.thumbs = this.root.querySelector('[data-qv-thumbs]');
        this.titleEl = this.root.querySelector('[data-qv-title]');
        this.priceEl = this.root.querySelector('[data-qv-price]');
        this.ratingEl = this.root.querySelector('[data-qv-rating]');
        this.uspsEl = this.root.querySelector('[data-qv-usps]');
        this.optionsEl = this.root.querySelector('[data-qv-options]');
        this.stockEl = this.root.querySelector('[data-qv-stock]');
        this.deliveryEl = this.root.querySelector('[data-qv-delivery]');
        this.atcBtn = this.root.querySelector('[data-qv-atc]');
        this.viewLink = this.root.querySelector('[data-qv-view]');
        this.actionsEl = this.root.querySelector('[data-qv-actions]');
        this.bundleLink = this.root.querySelector('[data-qv-bundle-link]');
        this.errorEl = this.root.querySelector('[data-qv-error]');
        this.closeBtn = this.root.querySelector('[data-qv-close]');

        this.root.querySelector('[data-qv-overlay]').addEventListener('click', () => this.close());
        this.closeBtn.addEventListener('click', () => this.close());
        this.atcBtn.addEventListener('click', () => this.addToCart());
        this.gallery.addEventListener('pointerdown', (e) => this.onGalleryDrag(e));
        this.mainMedia.addEventListener('pointerdown', (e) => this.onMainDrag(e));
        this.mainMedia.addEventListener('scroll', () => this.onMainScroll());
        this.thumbs.addEventListener('pointerdown', (e) => this.onThumbsDrag(e));
        this.thumbs.addEventListener('wheel', (e) => this.onThumbsWheel(e), { passive: false });
        // browsers try to drag the <img> itself, which hijacks drag-to-scroll
        this.root.addEventListener('dragstart', (e) => e.preventDefault());

        this.onKeydown = (e) => {
          if (e.key === 'Escape') this.close();
          if (e.key === 'Tab') this.trapFocus(e);
        };
      }

      open(data) {
        this.data = data;
        this.chartMode = false;
        this.adding = false;
        this.imageIndex = 0;
        this.returnFocus = document.activeElement;

        // preselect the first available variant's options (design behaviour)
        const first = data.variants.find((v) => v.available) || data.variants[0];
        this.selected = first ? first.options.slice() : [];
        if (first && first.mediaId) {
          const idx = data.images.findIndex((img) => img.mediaId === first.mediaId);
          if (idx > -1) this.imageIndex = idx;
        }

        this.isBundleMode = !!(data.isBundle && Array.isArray(data.bundleItems) && data.bundleItems.length);
        this.bundleMap = this.isBundleMode ? this.computeBundleMap() : null;
        this.card.classList.toggle('qv-modal__card--bundle', this.isBundleMode);

        this.root.classList.toggle('qv-modal--slide', data.settings.anim === 'slide-up');
        this.card.setAttribute('aria-label', data.title);
        this.titleEl.textContent = data.title;
        this.viewLink.href = data.url;
        this.viewLink.textContent = data.strings.viewProduct;

        // Non-bundle products that belong to a bundle get an upsell link
        // (same custom.bundle_product metafield the cart drawer upgrade uses)
        const showBundleLink = !!(data.bundleUrl && !this.isBundleMode);
        this.bundleLink.hidden = !showBundleLink;
        if (showBundleLink) {
          this.bundleLink.href = data.bundleUrl;
          this.bundleLink.innerHTML = '';
          const label = document.createElement('span');
          label.className = 'qv-view-bundle__label';
          label.textContent = data.strings.viewBundle;
          const badge = document.createElement('span');
          badge.className = 'qv-view-bundle__badge';
          badge.textContent = data.strings.viewBundleBadge;
          this.bundleLink.append(label, badge);
        }
        this.actionsEl.classList.toggle('qv-actions--bundle-link', showBundleLink);
        this.errorEl.hidden = true;

        this.deliveryEl.textContent = data.strings.delivery.replace('[date]', qvFormatDate(qvDeliveryDate()));
        this.deliveryEl.hidden = false;

        this.renderRating();
        this.renderUsps();
        this.renderMedia();
        this.renderOptions();
        this.updateAtc();

        this.root.hidden = false;
        document.body.classList.add('overflow-hidden', 'qv-open');
        document.addEventListener('keydown', this.onKeydown);
        this.closeBtn.focus();
      }

      close() {
        if (this.root.hidden) return;
        this.root.hidden = true;
        document.body.classList.remove('overflow-hidden', 'qv-open');
        document.removeEventListener('keydown', this.onKeydown);
        if (this.returnFocus && document.contains(this.returnFocus)) this.returnFocus.focus();
      }

      trapFocus(e) {
        const focusables = Array.from(
          this.card.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])')
        ).filter((el) => !el.disabled && el.offsetParent !== null);
        if (!focusables.length) return;
        const firstEl = focusables[0];
        const lastEl = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === firstEl) {
          e.preventDefault();
          lastEl.focus();
        } else if (!e.shiftKey && document.activeElement === lastEl) {
          e.preventDefault();
          firstEl.focus();
        }
      }

      matchedVariant() {
        return this.data.variants.find((v) => v.options.every((val, i) => val === this.selected[i]));
      }

      valuePurchasable(optionIndex, value) {
        return this.data.variants.some(
          (v) =>
            v.available &&
            v.options[optionIndex] === value &&
            v.options.every((val, i) => i === optionIndex || val === this.selected[i])
        );
      }

      renderRating() {
        const r = this.data.rating;
        this.ratingEl.innerHTML = '';
        const value = r ? parseFloat(r.value) : 0;
        const count = r ? parseInt(r.count, 10) || 0 : 0;
        if (!r || !value || count < 1) {
          this.ratingEl.hidden = true;
          return;
        }
        this.ratingEl.hidden = false;

        const stars = document.createElement('span');
        stars.className = 'qv-stars';
        stars.setAttribute('aria-hidden', 'true');
        const fill = document.createElement('span');
        fill.className = 'qv-stars__fill';
        fill.textContent = '★★★★★';
        const pct = Math.max(0, Math.min(100, (value / (parseFloat(r.max) || 5)) * 100));
        fill.style.width = pct + '%';
        stars.appendChild(fill);
        stars.appendChild(document.createTextNode('★★★★★'));

        const label = document.createElement('span');
        const word = count === 1 ? this.data.strings.review : this.data.strings.reviews;
        label.textContent = `${parseFloat(value.toFixed(1))} · ${count.toLocaleString()} ${word}`;

        this.ratingEl.append(stars, label);
      }

      renderUsps() {
        let usps = this.data.usps;
        if (this.data.isBundle) {
          // Same copy as the cart drawer's bundle upgrade modal; puppy bundles
          // don't qualify for free shipping
          usps = ['Bundle and save!'];
          if (!this.data.title.toLowerCase().includes('puppy')) usps.push('Free shipping');
        }
        const show = this.data.settings.showUsps && Array.isArray(usps) && usps.length;
        this.uspsEl.innerHTML = '';
        this.uspsEl.style.display = show ? '' : 'none';
        if (!show) return;
        usps.forEach((text) => {
          const row = document.createElement('div');
          row.className = 'qv-usp';
          const check = document.createElement('span');
          check.className = 'qv-usp__check';
          check.textContent = '✓';
          const label = document.createElement('span');
          label.textContent = text;
          row.append(check, label);
          this.uspsEl.appendChild(row);
        });
      }

      renderMedia() {
        const { images } = this.data;

        // Desktop: swipeable main carousel + circular thumbnails
        this.mainMedia.innerHTML = '';
        const makeMainSlide = (src, alt, isChart) => {
          const slide = document.createElement('div');
          slide.className = 'qv-main-slide';
          const im = document.createElement('img');
          im.draggable = false;
          im.src = src;
          im.alt = alt;
          if (isChart) im.className = 'qv-img--chart';
          slide.appendChild(im);
          return slide;
        };
        if (this.chartMode) {
          this.mainMedia.appendChild(makeMainSlide(this.data.sizeChart, this.data.strings.sizingInfo, true));
        } else {
          images.forEach((img) => {
            this.mainMedia.appendChild(makeMainSlide(img.src, img.alt || this.data.title, false));
          });
        }
        this.mainMedia.scrollLeft = this.chartMode ? 0 : this.imageIndex * this.mainMedia.clientWidth;

        const prevThumbScroll = this.thumbs.scrollLeft;
        this.thumbs.innerHTML = '';
        images.forEach((img, i) => {
          const t = document.createElement('button');
          t.type = 'button';
          t.className = 'qv-thumb' + (!this.chartMode && i === this.imageIndex ? ' is-active' : '');
          t.title = img.alt || '';
          const ti = document.createElement('img');
          ti.draggable = false;
          ti.src = img.thumb;
          ti.alt = '';
          t.appendChild(ti);
          t.addEventListener('click', () => {
            this.nudgeThumb(t);
            this.setImage(i);
          });
          this.thumbs.appendChild(t);
        });
        this.thumbs.scrollLeft = prevThumbScroll;

        // Mobile: swipeable slides
        this.gallery.innerHTML = '';
        const slides = this.chartMode
          ? [{ src: this.data.sizeChart, alt: this.data.strings.sizingInfo, chart: true }]
          : images;
        slides.forEach((img) => {
          const slide = document.createElement('div');
          slide.className = 'qv-slide';
          const si = document.createElement('img');
          si.draggable = false;
          si.src = img.src;
          si.alt = img.alt || this.data.title;
          if (img.chart) si.className = 'qv-img--chart';
          slide.appendChild(si);
          this.gallery.appendChild(slide);
        });
        this.gallery.scrollLeft = 0;
      }

      // Update the main image + active thumbnail in place (no strip rebuild,
      // so the thumbnail scroll position survives)
      setImage(index) {
        this.imageIndex = index;
        if (this.chartMode) {
          this.chartMode = false;
          this.renderMedia();
          this.renderOptions();
          const active = this.thumbs.children[index];
          if (active) this.nudgeThumb(active);
          return;
        }
        this.mainMedia.scrollTo({ left: index * this.mainMedia.clientWidth, behavior: 'smooth' });
        Array.from(this.thumbs.children).forEach((t, i) => t.classList.toggle('is-active', i === index));
      }

      // Clicking an edge thumbnail scrolls just enough to peek the neighbour
      nudgeThumb(el) {
        const c = this.thumbs;
        const peek = el.offsetWidth * 0.6 + 10;
        const left = el.getBoundingClientRect().left - c.getBoundingClientRect().left + c.scrollLeft;
        if (left + el.offsetWidth + peek > c.scrollLeft + c.clientWidth) {
          c.scrollTo({ left: left + el.offsetWidth + peek - c.clientWidth, behavior: 'smooth' });
        } else if (left - peek < c.scrollLeft) {
          c.scrollTo({ left: Math.max(0, left - peek), behavior: 'smooth' });
        }
      }

      // Mouse-drag scrolling for the thumbnail strip (touch uses native scrolling);
      // a real drag swallows the click so it doesn't select a thumbnail
      onThumbsDrag(e) {
        if (e.pointerType === 'touch') return;
        const c = this.thumbs;
        const startX = e.clientX;
        const startLeft = c.scrollLeft;
        let dragged = false;
        const move = (ev) => {
          if (Math.abs(ev.clientX - startX) > 5) dragged = true;
          if (dragged) {
            c.scrollLeft = startLeft - (ev.clientX - startX);
            c.style.cursor = 'grabbing';
          }
        };
        const up = () => {
          window.removeEventListener('pointermove', move);
          window.removeEventListener('pointerup', up);
          c.style.cursor = '';
          if (dragged) {
            const sup = (ev) => {
              ev.stopPropagation();
              ev.preventDefault();
            };
            c.addEventListener('click', sup, { capture: true, once: true });
            setTimeout(() => c.removeEventListener('click', sup, { capture: true }), 0);
          }
        };
        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', up);
      }

      // Vertical mouse wheel scrolls the strip horizontally
      onThumbsWheel(e) {
        const c = this.thumbs;
        if (c.scrollWidth <= c.clientWidth) return;
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          e.preventDefault();
          c.scrollLeft += e.deltaY;
        }
      }

      renderOptions() {
        const { options, strings, sizeChart } = this.data;
        this.optionsEl.innerHTML = '';

        if (this.isBundleMode) {
          this.renderBundleItemsUI();
          return;
        }

        const isDefaultOnly =
          options.length === 1 && options[0].values.length === 1 && options[0].values[0] === 'Default Title';
        if (isDefaultOnly) return;

        // "Sizing Info" link goes on the size-like option group (or the first one)
        let sizingIndex = options.findIndex((o) => /size/i.test(o.name));
        if (sizingIndex === -1) sizingIndex = 0;

        options.forEach((option, optionIndex) => {
          const group = document.createElement('div');
          group.className = 'qv-option';

          const header = document.createElement('div');
          header.className = 'qv-option__header';
          const label = document.createElement('div');
          label.className = 'qv-option__label';
          label.textContent = option.name;
          header.appendChild(label);

          if (sizeChart && optionIndex === sizingIndex) {
            const link = document.createElement('button');
            link.type = 'button';
            link.className = 'qv-sizing-link';
            link.textContent = this.chartMode ? strings.backToPhotos : strings.sizingInfo;
            link.addEventListener('click', () => {
              this.chartMode = !this.chartMode;
              this.renderMedia();
              this.renderOptions();
            });
            header.appendChild(link);
          }
          group.appendChild(header);

          const chips = document.createElement('div');
          chips.className = 'qv-chips';
          const isSizeOption = /size/i.test(option.name);
          option.values.forEach((value) => {
            const chip = document.createElement('button');
            chip.type = 'button';
            chip.className = 'qv-chip' + (this.selected[optionIndex] === value ? ' is-selected' : '');
            const display = isSizeOption ? qvSizeAbbrev(value) : value;
            chip.textContent = display;
            if (display !== value) {
              chip.title = value;
              chip.setAttribute('aria-label', value);
            }
            if (!this.valuePurchasable(optionIndex, value)) chip.disabled = true;
            chip.addEventListener('click', () => {
              this.selected[optionIndex] = value;
              this.errorEl.hidden = true;
              const variant = this.matchedVariant();
              if (variant && variant.mediaId) {
                const idx = this.data.images.findIndex((img) => img.mediaId === variant.mediaId);
                if (idx > -1) {
                  this.setImage(idx);
                  const activeThumb = this.thumbs.children[idx];
                  if (activeThumb) this.nudgeThumb(activeThumb);
                }
              }
              this.renderOptions();
              this.updateAtc();
            });
            chips.appendChild(chip);
          });
          group.appendChild(chips);
          this.optionsEl.appendChild(group);
        });
      }

      updateAtc() {
        const { strings } = this.data;
        const variant = this.matchedVariant();
        this.atcBtn.classList.remove('is-added', 'is-loading');

        if (!variant) {
          this.atcBtn.disabled = true;
          this.atcBtn.textContent = strings.unavailable;
        } else if (!variant.available) {
          this.atcBtn.disabled = true;
          this.atcBtn.textContent = strings.soldOut;
        } else {
          this.atcBtn.disabled = false;
          this.atcBtn.textContent = `${strings.addToCart} — ${variant.price}`;
        }

        this.updateStockNote(variant);

        this.priceEl.innerHTML = '';
        const source = variant || this.data.variants[0];
        if (!source) return;
        this.priceEl.appendChild(document.createTextNode(source.price));
        if (source.compareAtPrice) {
          const compare = document.createElement('s');
          compare.className = 'qv-price__compare';
          compare.textContent = source.compareAtPrice;
          this.priceEl.appendChild(compare);
          if (source.percentOff) {
            const pill = document.createElement('span');
            pill.className = 'qv-price__pill';
            pill.textContent = `${source.percentOff}% OFF`;
            this.priceEl.appendChild(pill);
          }
        }
      }

      // Map each bundle-product option (e.g. "Collar Size") to the bundle item it
      // sizes. Name match first; then collar-before-harness, mirroring the cart
      // drawer upgrade modal's ordering; then any remaining multi-variant item.
      computeBundleMap() {
        const { options, bundleItems } = this.data;
        const map = new Array(options.length).fill(-1);
        const used = new Set();
        const isMulti = (j) => bundleItems[j].variants.length > 1;
        const isReal = (o) => !(o.values.length === 1 && o.values[0] === 'Default Title');

        options.forEach((o, i) => {
          if (!isReal(o)) return;
          const needle = o.name.toLowerCase().replace(/size/g, '').replace(/[^a-z\s]/g, ' ').trim();
          if (!needle) return;
          const j = bundleItems.findIndex(
            (item, k) => !used.has(k) && isMulti(k) && item.title.toLowerCase().includes(needle)
          );
          if (j > -1) {
            map[i] = j;
            used.add(j);
          }
        });

        const fallbackKeywords = ['collar', 'harness', ''];
        options.forEach((o, i) => {
          if (map[i] > -1 || !isReal(o)) return;
          for (const keyword of fallbackKeywords) {
            const j = bundleItems.findIndex(
              (item, k) => !used.has(k) && isMulti(k) && (!keyword || item.title.toLowerCase().includes(keyword))
            );
            if (j > -1) {
              map[i] = j;
              used.add(j);
              break;
            }
          }
        });
        return map;
      }

      renderBundleItemsUI() {
        const { options, bundleItems, strings, sizeChart } = this.data;

        // Item titles repeat the bundle's pattern name ("Collar - Red Tartan");
        // strip it so the rows read cleanly ("Collar")
        const titleParts = this.data.title.split(' - ');
        const patternSuffix = titleParts.length > 1 ? titleParts[titleParts.length - 1].trim().toLowerCase() : null;
        const cleanTitle = (title) => {
          if (!patternSuffix) return title;
          const parts = title.split(' - ');
          if (parts.length > 1 && parts[parts.length - 1].trim().toLowerCase() === patternSuffix) {
            return parts.slice(0, -1).join(' - ').trim();
          }
          return title;
        };

        const group = document.createElement('div');
        group.className = 'qv-option';

        const header = document.createElement('div');
        header.className = 'qv-option__header qv-option__header--bundle';
        const label = document.createElement('div');
        label.className = 'qv-option__label';
        label.textContent = `${strings.sizeLabel}:`;
        header.appendChild(label);
        // Bundles have no size chart — point to the product page instead
        const hint = document.createElement('span');
        hint.className = 'qv-bundle-sizing-hint';
        const hintParts = strings.bundleSizingHint.split('[link]');
        hint.appendChild(document.createTextNode(hintParts[0] || ''));
        const hintLink = document.createElement('a');
        hintLink.href = this.data.url;
        hintLink.textContent = strings.bundleSizingLink;
        hint.appendChild(hintLink);
        hint.appendChild(document.createTextNode(hintParts[1] || ''));
        header.appendChild(hint);
        group.appendChild(header);

        const grid = document.createElement('div');
        grid.className = 'qv-bundle';

        bundleItems.forEach((item, j) => {
          const row = document.createElement('div');
          row.className = 'qv-bundle__item';

          if (item.image) {
            const img = document.createElement('img');
            img.className = 'qv-bundle__img';
            img.draggable = false;
            img.src = item.image;
            img.alt = item.title;
            img.loading = 'lazy';
            row.appendChild(img);
          }

          const name = document.createElement('div');
          name.className = 'qv-bundle__name';
          name.textContent = cleanTitle(item.title);
          name.title = item.title;
          row.appendChild(name);

          const optionIndex = this.bundleMap.indexOf(j);
          if (optionIndex > -1) {
            const select = document.createElement('select');
            select.className = 'qv-bundle__select';
            select.setAttribute('aria-label', `${item.title} — ${strings.sizeLabel}`);
            options[optionIndex].values.forEach((value) => {
              const opt = document.createElement('option');
              opt.value = value;
              const purchasable = this.valuePurchasable(optionIndex, value);
              opt.textContent = qvSizeAbbrev(value) + (purchasable ? '' : ` ${strings.soldOutSuffix}`);
              opt.disabled = !purchasable;
              opt.selected = this.selected[optionIndex] === value;
              select.appendChild(opt);
            });
            select.addEventListener('change', () => {
              this.selected[optionIndex] = select.value;
              this.errorEl.hidden = true;
              const variant = this.matchedVariant();
              if (variant && variant.mediaId) {
                const idx = this.data.images.findIndex((img) => img.mediaId === variant.mediaId);
                if (idx > -1) {
                  this.setImage(idx);
                  const activeThumb = this.thumbs.children[idx];
                  if (activeThumb) this.nudgeThumb(activeThumb);
                }
              }
              this.renderOptions();
              this.updateAtc();
            });
            row.appendChild(select);
          } else {
            const pill = document.createElement('span');
            pill.className = 'qv-bundle__single';
            const title = item.variants.length ? item.variants[0].title : '';
            pill.textContent = !title || title === 'Default Title' ? strings.oneSize : title;
            row.appendChild(pill);
          }

          grid.appendChild(row);
        });

        group.appendChild(grid);
        this.optionsEl.appendChild(group);
      }

      updateStockNote(variant) {
        const threshold = this.data.settings.lowStockThreshold || 10;
        const show =
          variant &&
          variant.available &&
          typeof variant.qty === 'number' &&
          variant.qty > 0 &&
          variant.qty <= threshold;
        if (!show) {
          this.stockEl.hidden = true;
          return;
        }
        const sizeIndex = this.data.options.findIndex((o) => /size/i.test(o.name));
        // Bundles: a size name alone is ambiguous across items, so use the plain wording
        const sizeValue = sizeIndex > -1 && !this.isBundleMode ? this.selected[sizeIndex] : null;
        const template = sizeValue ? this.data.strings.lowStockIn : this.data.strings.lowStock;
        this.stockEl.textContent = template
          .replace('[count]', variant.qty)
          .replace('[size]', sizeValue ? qvSizeAbbrev(sizeValue) : '');
        this.stockEl.hidden = false;
      }

      async addToCart() {
        if (this.adding) return;
        const variant = this.matchedVariant();
        if (!variant || !variant.available) return;

        this.adding = true;
        this.errorEl.hidden = true;
        this.atcBtn.classList.add('is-loading');
        this.atcBtn.setAttribute('aria-disabled', 'true');

        const result = await qvAddToCart(variant.id);

        this.atcBtn.classList.remove('is-loading');
        this.atcBtn.removeAttribute('aria-disabled');

        if (!result.ok) {
          this.adding = false;
          this.errorEl.textContent = result.message;
          this.errorEl.hidden = false;
          return;
        }

        this.atcBtn.classList.add('is-added');
        this.atcBtn.textContent = this.data.strings.added;

        setTimeout(() => {
          this.adding = false;
          this.close();
          qvShowCart(result.cart, result.response);
        }, 900);
      }

      onGalleryDrag(e) {
        this.carouselDrag(this.gallery, e, 12);
      }

      onMainDrag(e) {
        if (this.chartMode || this.mainMedia.children.length < 2) return;
        this.carouselDrag(this.mainMedia, e, 0);
      }

      // Keep the active thumbnail in sync while the main carousel is swiped
      onMainScroll() {
        clearTimeout(this._mainScrollTimer);
        this._mainScrollTimer = setTimeout(() => {
          if (!this.data || this.chartMode) return;
          const width = this.mainMedia.clientWidth;
          if (!width) return;
          const idx = Math.max(0, Math.min(Math.round(this.mainMedia.scrollLeft / width), this.data.images.length - 1));
          if (idx === this.imageIndex) return;
          this.imageIndex = idx;
          Array.from(this.thumbs.children).forEach((t, i) => t.classList.toggle('is-active', i === idx));
          const active = this.thumbs.children[idx];
          if (active) this.nudgeThumb(active);
        }, 90);
      }

      // Mouse-drag with flick detection for a snap carousel (touch uses native scrolling)
      carouselDrag(el, e, gap) {
        if (e.pointerType === 'touch') return;
        e.preventDefault();
        const startX = e.clientX;
        const startLeft = el.scrollLeft;
        const startT = performance.now();
        let lastX = startX;
        el.style.scrollSnapType = 'none'; // snap fights manual scrollLeft — off while dragging
        el.style.cursor = 'grabbing';
        const move = (ev) => {
          lastX = ev.clientX;
          el.scrollLeft = startLeft - (lastX - startX);
        };
        const up = () => {
          window.removeEventListener('pointermove', move);
          window.removeEventListener('pointerup', up);
          el.style.cursor = 'grab';
          const slideW = el.firstElementChild ? el.firstElementChild.offsetWidth + gap : el.clientWidth;
          const dx = lastX - startX;
          const dt = performance.now() - startT;
          let idx;
          if (Math.abs(dx) > 30 && dt < 350) idx = Math.round(startLeft / slideW) + (dx < 0 ? 1 : -1);
          else idx = Math.round(el.scrollLeft / slideW);
          idx = Math.max(0, Math.min(idx, el.children.length - 1));
          el.scrollTo({ left: idx * slideW, behavior: 'smooth' });
          const done = () => {
            el.style.scrollSnapType = 'x mandatory';
            el.removeEventListener('scrollend', done);
          };
          if ('onscrollend' in el) el.addEventListener('scrollend', done);
          else setTimeout(done, 600);
        };
        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', up);
      }
    }

    let modalInstance = null;
    const getModal = () => {
      if (!modalInstance) modalInstance = new QuickViewModal();
      return modalInstance;
    };

    customElements.define(
      'quick-view-button',
      class QuickViewButton extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button');
          const payload = this.querySelector('script[type="application/json"]');
          if (!this.button || !payload) return;
          try {
            this.data = JSON.parse(payload.textContent);
          } catch (e) {
            console.error('quick-view: invalid payload', e);
            return;
          }
          this.button.addEventListener('click', () => this.onClick());
        }

        onClick() {
          if (!this.data || !this.data.available || this.busy) return;
          const { options, variants } = this.data;
          const isDefaultOnly =
            variants.length === 1 &&
            options.length === 1 &&
            options[0].values.length === 1 &&
            options[0].values[0] === 'Default Title';
          const showsBundleContents =
            this.data.isBundle && Array.isArray(this.data.bundleItems) && this.data.bundleItems.length;

          if (isDefaultOnly && !showsBundleContents) {
            this.directAdd(variants[0].id);
          } else {
            getModal().open(this.data);
          }
        }

        async directAdd(variantId) {
          this.busy = true;
          const label = this.button.querySelector('.qv-card-btn__label') || this.button;
          const original = label.textContent;
          this.button.classList.add('is-loading');

          const result = await qvAddToCart(variantId);
          this.button.classList.remove('is-loading');

          if (!result.ok) {
            this.busy = false;
            label.textContent = result.message || original;
            setTimeout(() => {
              label.textContent = original;
            }, 2000);
            return;
          }

          this.button.classList.add('is-added');
          label.textContent = this.data.strings.added;
          qvShowCart(result.cart, result.response);
          setTimeout(() => {
            this.button.classList.remove('is-added');
            label.textContent = original;
            this.busy = false;
          }, 1400);
        }
      }
    );
  })();
}
